import api from '../../api';

export const getSortedListRequest = (params) =>
    api.get(`sort/${params.value}/get`, { params });

export const getSearchListCountRequest = (params) =>
    api.get(`search/list/count`, { params });
